import { memo } from 'react';

function SuccessIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="19"
			fill="none"
			viewBox="0 0 18 19"
		>
			<circle cx="9" cy="9.087" r="9" fill="#5FD08C"></circle>
			<path
				stroke="#fff"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
				d="M5 8.905l2.857 3.182 5.143-5"
			></path>
		</svg>
	);
}

export default memo(SuccessIcon);
